import { isServer, QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/shared/api';

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: isServer ? Infinity : 5 * 60_000,
        retry: (count, error) => count < 1 && !(error instanceof ApiError && error.status < 500),
        refetchOnWindowFocus: true,
      },
      mutations: { retry: false },
    },
  });
}
